export default __webpack_public_path__ + "static/media/foxtel.02c09acf.svg";